import { CheironLogo } from '@assets/svg/Logos/CheironLogo'
import { MAIN_DOMAIN } from '@utils/auth-mode'

export const AuthLayout: React.FC<{
  children: React.ReactNode
  className?: string
}> = ({ children, className = '' }) => {
  const queryParams = new URLSearchParams(window.location.search)
  const redirect = queryParams.get('redirect')
  const redirectUrl = redirect ? decodeURIComponent(redirect) : MAIN_DOMAIN

  return (
    <div
      className={`flex flex-col w-full h-screen bg-neutral-50 ${className}`}
    >
      <a
        href={`${window.location.protocol}//${redirectUrl}/`}
        className='fixed top-[26px] left-[34px]'
      >
        <CheironLogo />
      </a>
      <div className='flex-1 flex justify-center items-center'>{children}</div>
    </div>
  )
}
